import * as _ from 'lodash';
import moment from 'moment';

export interface AppUser {
  idUserPk?: number;
  cdNuuma?: string;
  txtName?: string;
  txtLastname1?: string;
  txtLastname2?: string;
  txtMail?: string;
  fullName?: string;
  txtFullname?: string;
  mrkActive?: boolean | number;
  mobilityFunctional?: boolean;
  mobilityGeographic?: boolean;
  [key: string]: any;
}

export function buildUserFullName(user: AppUser): string {
  const lastname1 = user?.txtLastname1 ? ' ' + user.txtLastname1 : '';
  const lastname2 = user?.txtLastname2 ? ' ' + user.txtLastname2 : '';
  const name = user?.txtName ? user.txtName : '';
  return name + lastname1 + lastname2;
}

/** Copia el usuario del backend y le añade los campos calculados que usa la UI. */
export function normalizeUser(raw: any): AppUser {
  const user: AppUser = { ...raw };
  user.mrkActive = user.mrkActive ?? false;
  user.mobilityFunctional = user.mobilityFunctional ?? false;
  user.mobilityGeographic = user.mobilityGeographic ?? false;
  user.fullName = buildUserFullName(user);
  user.txtFullname = user.fullName;
  return user;
}

export function normalizeUsers(raw: any[]): AppUser[] {
  return _.map(raw, normalizeUser);
}

/** Formato que espera el backend para crear/actualizar un usuario desde administración. */
export function mapToBackAdminUser(user: AppUser) {
  return {
    cdNuuma: user.cdNuuma,
    txtName: user.txtName,
    txtLastname1: user.txtLastname1,
    txtLastname2: user.txtLastname2,
    mrkActive: user.mrkActive ?? false,
    txtMail: user.txtMail,
    language: user['language'],
    entamap: user['entamap'],
    nmrMobile: user['nmrMobile'],
    dateAdmission: moment(user['dateAdmission']).format('YYYY-MM-DD'),
    workLeaveDate: user['workLeaveDate'],
    txtComment: user['txtComment'],
    filePhotoName: user['filePhotoName'],
    fileFirmName: user['fileFirmName'],
    fileCvEsName: user['fileCvEsName'],
    fileCvEnName: user['fileCvEnName'],
    roles: user['roles'],
    organizationalStructure: user['organizationalStructure'],
    professionalCategoryTypes: user['professionalCategoryTypes'],
    mobilityFunctional: user.mobilityFunctional ?? false,
    mobilityGeographic: user.mobilityGeographic ?? false,
    typeTreatment: user['typeTreatment'],
    secondaryOrgStrIds: user['secondaryOrgStr'] !== undefined ? _.map(user['secondaryOrgStr'], 'idOrganizationalStructurePk') : [],
    assistedUsers: user['assistedUsers'],
    evaluableUsers: user['evaluableUsers']
  };
}
